import { Tag } from "Domain/Model/Tag/Tag";

export const FIND_TAG_SUCCESS = 'FIND_TAG_SUCCESS';

export const findTagSuccess = (tag: Record<string, Tag>) => ({
    type: FIND_TAG_SUCCESS,
    payload: { tag },
});
